import React, { useState, useEffect } from "react";
import { Link } from "@quintype/components";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import ShareMenuItems from "./ShareMenuItems";
import { shortenUrl } from "../../../../api/utils";
import { getStoryHeadline } from "../../utils/story";

import "./recipe.m.css";

export default function RecipeShare({ story }) {
  const [shareMenuOpen, setShareMenuOpen] = useState(false);
  const [copyPopupOpen, setCopyPopupOpen] = useState(false);
  const [shortStoryUrl, setShortStoryUrl] = useState(story?.url);
  const headline = getStoryHeadline(story);

  const handlePrint = () => {
    window.print();
    return false;
  };

  useEffect(() => {
    const closeShareMenu = () => setShareMenuOpen(false);
    document.body.addEventListener("click", closeShareMenu);

    return () => {
      document.body.removeEventListener("click", closeShareMenu);
    };
  }, []);

  useEffect(() => {
    const item = document.getElementById("copy-link");
    if (item !== null) {
      item.addEventListener("click", function () {
        setCopyPopupOpen(true);
        setTimeout(() => {
          setCopyPopupOpen(false);
        }, 3000);
      });
      navigator.clipboard.writeText(shortStoryUrl);
    }
  }, [shareMenuOpen, shortStoryUrl]);

  useEffect(() => {
    const fetchShortUrl = async () => {
      try {
        const data = await shortenUrl(story?.url);
        setShortStoryUrl(data?.shortUrl);
      } catch (err) {
        console.error("Failed to shorten URL: ", err);
      }
    };

    if (story?.url) {
      fetchShortUrl();
    }
  }, [story?.url]);

  return (
    <div styleName="recipe-share-menu-container">
      <div styleName="share-icons-div">
        <div onClick={handlePrint}>
          <Link>
            <SvgIconHandler type="print" width="24px" height="24px" />
            <span>PRINT</span>
          </Link>
        </div>
        <div>
          <Link href={`mailto:?subject=${headline}&body=${shortStoryUrl}`} target="_blank">
            <SvgIconHandler type="recipe-share-mail" width="24px" height="24px" />
            <span>EMAIL</span>
          </Link>
        </div>
        <div tabIndex={0} styleName="recipe-share" onClick={() => setShareMenuOpen(true)}>
          <SvgIconHandler type="recipe-share-menu" height="24px" width="24px" viewBox="0 0 24 24" />
          <span>SHARE</span>
        </div>
      </div>
      {shareMenuOpen && (
        <div styleName="recipe-share-menu">
          <ShareMenuItems story={story} copyPopupOpen={copyPopupOpen} setCopyPopupOpen={setCopyPopupOpen} />
          <div>
            <SvgIconHandler type="share-link" height="32px" width="32px" viewBox="0 0 32 32" />
            <span id="copy-link">Copy link</span>
          </div>
        </div>
      )}
      {copyPopupOpen && <span styleName="copy-link">Link copied!</span>}
    </div>
  );
}
